import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10cc0cf5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "usercenter-order-confirm-order" }
const _hoisted_2 = { class: "confirm-order-title" }
const _hoisted_3 = { class: "confirm-order-table" }
const _hoisted_4 = ["src"]

import { ref, computed } from 'vue'
import { t } from '@/plugins/i18n'
import STable from '@/components/Table/index.vue'
import FigurePay from '@/views/shopcart/components/FigurePay.vue'
import { confirmOrderDetailApi, batchPayOrderApi } from '@/apis/order'
import { columns, childColumns } from './data'
import { useRoute, useRouter } from 'vue-router'
import { ElMessageBox, ElMessage } from 'element-plus'
import { useRtfix, usePlat, isD2C } from '@/store'
import NoStockModal from '@/views/shopcart/components/NoStockModal.vue'
import { montageAddition } from '@/util/calcAdt'
import { showCurrentUnit } from '@/util/useYan'
import { COUNTRY } from '@/global'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()

const tableData:any = ref([])
const pdtFee = ref(0)
const adtFee = ref(0)
const figurePayRef = ref()
const visible = ref(false)
const goods:any = ref([])
const blackGoods:any = ref([])
const tableConfig = {
  // showSelection: true,
  // showHandler: true,
  showExpand: true,
  canRowClick: true,
  rowKey: 'platformOrderId',
  setHeight: true
}
const submit = () => {
  batchPayOrderApi({
    platformOrderIds: route.query.id?.toString().split(',') || []
  }).then((res: any) => {
    if (res.success) {
      const { stockSkus, downSkus, validSkus, blackSkuList } = res.data
      if (stockSkus?.length > 0 || blackSkuList?.length > 0) {
        const list:any = []
        const blackList:any = []
        tableData.value.forEach((item:any) => {
          item.platformOrderItems.forEach((temp:any) => {
            if (stockSkus?.includes(temp.productSku) && temp.channel === 5) {
              list.push({
                ...temp,
                price: temp.actualPrice
              })
            }
            if (blackSkuList?.includes(temp.productSku)) {
              blackList.push({
                ...temp,
                price: temp.actualPrice
              })
            }
          })
        })
        if (list.length > 0 || blackList.length > 0) {
          goods.value = list
          blackGoods.value = blackList
          visible.value = true
        } else {
          ElMessage.warning(t('支付失败'))
        }
        return
      } else if (downSkus?.length || validSkus?.length) {
        ElMessage.warning(t('支付失败'))
        return
      }
      ElMessageBox.confirm(
        t('支付成功'),
        t('提示'),
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: t('确定'),
          distinguishCancelAndClose: true,
          customClass: 'stupid-el',
          type: 'success',
          showClose: false,
          showCancelButton: false,
          closeOnClickModal: false
        }
      ).then(() => {
        router.push(useRtfix('OrderList'))
      })
    }
  })
}
confirmOrderDetailApi({
  platformOrderIds: route.query.id?.toString().split(',') || []
}).then((res: any) => {
  if (res.success) {
    tableData.value = res.data.platformOrders
    tableData.value.forEach((item: any) => {
      pdtFee.value += item.productPaymentFreezeAmount
      adtFee.value += item.productAdditionFreezeAmount
    })
  }
})
const unit = computed(() => {
  if (tableData.value.length === 0) return ''
  return showCurrentUnit(tableData.value[0]?.goodsCountry === COUNTRY.KR)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('确认订单信息')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(STable, {
        tableData: tableData.value,
        columns: _unref(columns),
        tableConfig: tableConfig,
        showPagination: false
      }, {
        expand: _withCtx(({ scope }) => [
          _createVNode(STable, {
            tableData: scope.row.platformOrderItems,
            columns: _unref(childColumns),
            showPagination: false
          }, {
            productSkuImg: _withCtx(({ row }) => [
              _createElementVNode("img", {
                src: row.productSkuImg,
                alt: "",
                style: {"width":"60px"}
              }, null, 8, _hoisted_4)
            ]),
            frezeeQuantity: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(row.freezeQuantity) + "/" + _toDisplayString(row.sellQuantity), 1)
            ]),
            platformOrderItemAdditionList: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_unref(montageAddition)(row.platformOrderItemAdditionList)), 1)
            ]),
            actualPrice: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(row.actualPrice) + " " + _toDisplayString(_unref(unit)), 1)
            ]),
            productAdditionFreezeAmount: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(row.productAdditionFreezeAmount) + " " + _toDisplayString(_unref(unit)), 1)
            ]),
            totalFreezeAmount: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(row.totalFreezeAmount) + " " + _toDisplayString(_unref(unit)), 1)
            ]),
            _: 2
          }, 1032, ["tableData", "columns"])
        ]),
        productPaymentFreezeAmount: _withCtx(({ row }) => [
          _createElementVNode("div", null, _toDisplayString(row.productPaymentFreezeAmount) + " " + _toDisplayString(_unref(unit)), 1)
        ]),
        productAdditionFreezeAmount: _withCtx(({ row }) => [
          _createElementVNode("div", null, _toDisplayString(row.productAdditionFreezeAmount) + " " + _toDisplayString(_unref(unit)), 1)
        ]),
        totalFreezeAmount: _withCtx(({ row }) => [
          _createElementVNode("div", null, _toDisplayString(row.totalFreezeAmount) + " " + _toDisplayString(_unref(unit)), 1)
        ]),
        _: 1
      }, 8, ["tableData", "columns"])
    ]),
    _createVNode(FigurePay, {
      hiddenGroupBtn: true,
      onSubmit: submit,
      pdtFee: pdtFee.value,
      adtFee: adtFee.value,
      ref: (_value, _refs) => {
        _refs['figurePayRef'] = _value
        figurePayRef.value = _value
      },
      emitSubmit: true
    }, null, 8, ["pdtFee", "adtFee"]),
    _createVNode(NoStockModal, {
      visible: visible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
      goods: goods.value,
      blackGoods: blackGoods.value
    }, null, 8, ["visible", "goods", "blackGoods"])
  ]))
}
}

})